import { render, staticRenderFns } from "./contentCourseLearnerEditFaceDetection.vue?vue&type=template&id=78718232&"
import script from "./contentCourseLearnerEditFaceDetection.vue?vue&type=script&lang=js&"
export * from "./contentCourseLearnerEditFaceDetection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports